export function popup() {
  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      "; expires=" +
      expires +
      "; path=/";
  }

  function getCookie(name) {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
  }

  if (!getCookie("popup_closed")) {
    document.getElementById("popup").style.display = "flex";
  }

  document
    .getElementById("popup-close")
    .addEventListener("click", function (e) {
      e.preventDefault();
      setCookie("popup_closed", "yes", 7);
      document.getElementById("popup").style.display = "none";
    });
}
